import { render } from "./BaseArrow.vue?vue&type=template&id=42b9360b&scoped=true&ts=true"
import script from "./BaseArrow.vue?vue&type=script&lang=ts"
export * from "./BaseArrow.vue?vue&type=script&lang=ts"

import "./BaseArrow.vue?vue&type=style&index=0&id=42b9360b&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42b9360b"]])

export default __exports__